import { defineCatalogue } from '../../../i18n';

export const publicationsCatalogue = defineCatalogue(
  {
    title: 'Publicações',
    'nav.overview': 'Visão geral',
    'nav.list': 'Lista',
    'window.label': 'Janela',
    'sort.label': 'Ordenação',
    'sort.recent': 'Mais recentes',
    'sort.reach': 'Maior alcance',
    'view.label': 'Visualização',
    'view.feed': 'Cartões',
    'view.list': 'Lista',
    'filter.open': 'Filtrar por tag',
    'filter.label': 'Tag',
    'filter.clear': 'Limpar',
    'filter.search': 'Buscar tag',
    'filter.none': 'Nenhuma tag encontrada',
    'filter.remove': 'Remover a tag {tag}',
    'empty.title': 'Nenhuma publicação neste recorte',
    'empty.description': 'A coleta da sua organização não trouxe publicações neste período.',
    'list.caption': 'Publicações da campanha',
    'list.post': 'Publicação',
    'list.reach': 'Alcance',
    'list.engagement': 'Engajamento',
    'list.sentiment': 'Sentimento',
    'list.mediaTile': 'Publicação com mídia',
    'list.textTile': 'Publicação em texto',
    'list.open': 'Abrir publicação',
    'metric.reach': 'Alcance',
    'metric.estimatedReach': 'Alcance estimado',
    'metric.likes': 'Curtidas',
    'metric.comments': 'Comentários na plataforma',
    'metric.shares': 'Compartilhamentos',
    'metric.saves': 'Salvamentos',
    'post.deleted': 'Removida da rede',
    'post.deletedOn': 'Removida em {date}',
    'post.noCaption': 'Sem legenda',
    'post.mediaAlt': 'Mídia da publicação',
    'network.instagram': 'Instagram',
    'network.tiktok': 'TikTok',
    'kind.feed_image': 'Foto',
    'kind.story': 'Story',
    'kind.post': 'Post',
    'kind.reel': 'Reel',
    'kindFilter.label': 'Tipo',
    'kindFilter.all': 'Todos',
    'kindFilter.post': 'Posts',
    'kindFilter.reel': 'Reels',
    'kindFilter.story': 'Stories',
    'story.capturedAt': 'capturado em {date}',
    'story.expiresIn': 'expira {when}',
    'story.expired': 'Expirada',
    'story.active': 'Ativa',
    more: 'Carregar mais',
    'loading.more': 'Carregando mais publicações',
    'figure.estimated': 'estimado',
    'sentiment.none': 'sem leitura',
    'sentiment.label': 'Sentimento {score}, {n} comentários analisados, intervalo {interval}',
    'loading.feed': 'Carregando publicações',
    'recorte.label': 'Recorte',
    'recorte.related': 'Relacionadas',
    'recorte.all': 'Todas',
    'recorte.unrelated': 'Não relacionadas',
    'recorte.unrelated.hint':
      'Não relacionadas: abaixo do limiar de relação ou ainda não analisadas',
  },
  {
    title: 'Posts',
    'nav.overview': 'Overview',
    'nav.list': 'List',
    'window.label': 'Window',
    'sort.label': 'Order',
    'sort.recent': 'Most recent',
    'sort.reach': 'Highest reach',
    'view.label': 'View',
    'view.feed': 'Cards',
    'view.list': 'List',
    'filter.open': 'Filter by tag',
    'filter.label': 'Tag',
    'filter.clear': 'Clear',
    'filter.search': 'Search tags',
    'filter.none': 'No tag found',
    'filter.remove': 'Remove the {tag} tag',
    'empty.title': 'No posts in this view',
    'empty.description': "Your organisation's collection returned no posts for this period.",
    'list.caption': 'Campaign posts',
    'list.post': 'Post',
    'list.reach': 'Reach',
    'list.engagement': 'Engagement',
    'list.sentiment': 'Sentiment',
    'list.mediaTile': 'Post with media',
    'list.textTile': 'Text post',
    'list.open': 'Open post',
    'metric.reach': 'Reach',
    'metric.estimatedReach': 'Estimated reach',
    'metric.likes': 'Likes',
    'metric.comments': 'Comments on the platform',
    'metric.shares': 'Shares',
    'metric.saves': 'Saves',
    'post.deleted': 'Removed from the network',
    'post.deletedOn': 'Removed on {date}',
    'post.noCaption': 'No caption',
    'post.mediaAlt': 'Post media',
    'network.instagram': 'Instagram',
    'network.tiktok': 'TikTok',
    'kind.feed_image': 'Photo',
    'kind.story': 'Story',
    'kind.post': 'Post',
    'kind.reel': 'Reel',
    'kindFilter.label': 'Type',
    'kindFilter.all': 'All',
    'kindFilter.post': 'Posts',
    'kindFilter.reel': 'Reels',
    'kindFilter.story': 'Stories',
    'story.capturedAt': 'captured {date}',
    'story.expiresIn': 'expires {when}',
    'story.expired': 'Expired',
    'story.active': 'Active',
    more: 'Load more',
    'loading.more': 'Loading more posts',
    'figure.estimated': 'estimated',
    'sentiment.none': 'no reading',
    'sentiment.label': 'Sentiment {score}, {n} comments analysed, interval {interval}',
    'loading.feed': 'Loading posts',
    'recorte.label': 'Scope',
    'recorte.related': 'Related',
    'recorte.all': 'All',
    'recorte.unrelated': 'Unrelated',
    'recorte.unrelated.hint': 'Unrelated: below the relatedness threshold or not yet analysed',
  },
);

export const pub = publicationsCatalogue.t;

/** A network- or content-kind token the frontend owns no vocabulary for:
 *  title-cased rather than shown as the wire's raw word. */
function humanize(raw: string): string {
  return raw
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

const NETWORK_KEYS: Record<string, 'network.instagram' | 'network.tiktok'> = {
  instagram: 'network.instagram',
  tiktok: 'network.tiktok',
};

const KIND_KEYS: Record<string, 'kind.feed_image' | 'kind.story' | 'kind.post' | 'kind.reel'> = {
  feed_image: 'kind.feed_image',
  story: 'kind.story',
  POST: 'kind.post',
  REEL: 'kind.reel',
  STORY: 'kind.story',
};

/** The post's network, named rather than shown as the wire's platform token. */
export function networkLabel(platform: string): string {
  const key = NETWORK_KEYS[platform];
  return key !== undefined ? pub(key) : humanize(platform);
}

/** The post's content kind, named rather than shown as the wire's kind token. */
export function kindLabel(kind: string): string {
  const key = KIND_KEYS[kind];
  return key !== undefined ? pub(key) : humanize(kind);
}

const KIND_FILTER_KEYS_MAP: Record<
  string,
  'kindFilter.post' | 'kindFilter.reel' | 'kindFilter.story'
> = {
  POST: 'kindFilter.post',
  REEL: 'kindFilter.reel',
  STORY: 'kindFilter.story',
};

/** The toolbar's own plural label for a kind filter option; `'all'` is
 *  `kindFilter.all`, every other value falls back the same way `kindLabel` does. */
export function kindFilterLabel(kind: 'all' | string): string {
  if (kind === 'all') return pub('kindFilter.all');
  const key = KIND_FILTER_KEYS_MAP[kind];
  return key !== undefined ? pub(key) : humanize(kind);
}
